import React, { useEffect } from "react";
import Chevron from "Utils/Assets/SVGs/Chevron";
import { useCarousel } from "../../../Logic/Functions/Hooks/useCarousel";
import styles from "./UiLibraryComponent.module.css";
import { CarouselProps } from "../../../Model/UIComponents.model";

const Carousel: React.FC<CarouselProps> = ({
  step = 0.85,
  prevAriaLabel = "Scroll previous",
  nextAriaLabel = "Scroll next",
  className = "",
  navClassName = "",
  prevBtnClassName = "",
  nextBtnClassName = "",
  viewportClassName = "",
  trackClassName = "",
  slideClassName = "",
  wrapSlides = true,
  prevIcon,
  nextIcon,
  children,
  resetKey,
}) => {
  const {
    viewportRef,
    trackRef,
    atStart,
    atEnd,
    scrollPrev,
    scrollNext,
    reset,
  } = useCarousel({ step });

  useEffect(() => {
    if (resetKey !== undefined) reset();
  }, [resetKey, reset]);

  return (
    <div className={`${styles.carousel} ${className}`} data-testid="carousel">
      <div className={`${styles.carouselNav} ${navClassName}`} data-testid="carousel-nav">
        <button
          type="button"
          className={`${styles.carouselBtn} ${prevBtnClassName}`}
          aria-label={prevAriaLabel}
          onClick={scrollPrev}
          data-testid="carousel-prev"
          disabled={atStart}
        >
          {prevIcon ?? <Chevron className={styles.carouselChevronLeft} />}
        </button>

        <div
          ref={viewportRef}
          className={`${styles.carouselViewport} ${viewportClassName}`}
          data-testid="carousel-viewport"
        >
          <div
            ref={trackRef}
            className={`${styles.carouselTrack} ${trackClassName}`}
            data-testid="carousel-track"
          >
            {wrapSlides
              ? React.Children.map(children, (child, i) => (
                  <div
                    className={`${styles.carouselSlide} ${slideClassName}`}
                    data-testid={`carousel-slide-${i}`}
                  >
                    {child}
                  </div>
                ))
              : children}
          </div>
        </div>

        <button
          type="button"
          className={`${styles.carouselBtn} ${nextBtnClassName}`}
          aria-label={nextAriaLabel}
          onClick={scrollNext}
          data-testid="carousel-next"
          disabled={atEnd}
        >
          {nextIcon ?? <Chevron className={styles.carouselChevronRight} />}
        </button>
      </div>
    </div>
  );
};

export default Carousel;
